<template>
  <SectionTabs :tabs="tabs" />
</template>

<script>
import SectionTabs from "@/components/SectionTabs.vue";

export default {
  name: "InternalChangesTabs",
  components: {
    SectionTabs,
  },
  data() {
    return {
      tabs: [
        { name: "turmas", label: "Turmas", routes: ["turmas", "nova-turma", "perfil-turma"] },
        { name: "ciclos", label: "Ciclos", routes: ["ciclos", "novo-ciclo"] },
        { name: "ciclos-de-matricula", label: "Ciclos de matrícula" },
        { name: "materias", label: "Áreas do Conhecimento", routes: ["materias", "perfil-materia"] },
        { name: "calendario-escolar", label: "Calendário" },
        {
          name: "mensalidade-escolar",
          label: "Mensalidade escolar",
          routes: ["mensalidade-escolar", "mensalidade-escolar-registrar", "precos-pititim-registrar"],
        },
      ],
    };
  },
};
</script>
